var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$route.matched[0].name,attrs:{"id":"app"}},[_c('Navigation'),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }